import { useParams } from "react-router-dom";
import { EditorPage } from "@/components/editor/EditorPage";

export function TemplateEditorPage() {
  const { id } = useParams<{ id: string }>();
  return <EditorPage key={id} mode="build" />;
}
